"use client";

import styles from "../../Supplier Management/css/supplierManagement.module.css";
import Navbar from "../../../../components/navbar";
import Footer from "../../../../components/footer";
import Popup from "../../../../components/Popup";
import { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import SupplierFormContainer from "../components/SupplierFormContainer";
import useSupplierManagement from "../components/useSupplierManagement";

export default function SupplierManagement() {
  const {
    activeFilter,
    setActiveFilter,
    search,
    setSearch,
    showAddForm,
    setShowAddForm,
    isEditing,
    setIsEditing,
    selectedSupplier,
    setSelectedSupplier,
    suppliers,
    setSuppliers,
    popupMsg,
    setPopupMsg,
    handleEdit,
    handleEnable,
    handleDisable,
  } = useSupplierManagement();

  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  useEffect(() => {
    const path = location.pathname;
    if (path.endsWith("/supplier-management/new")) {
      setIsEditing(false);
      setSelectedSupplier(null);
      setShowAddForm(true);
      return;
    }
    const editMatch = path.match(/\/supplier-management\/([^/]+)\/edit$/);
    if (editMatch) {
      const code = params.supplierCode || editMatch[1];
      const found = (suppliers || []).find((s) => s.suppliercode === code);
      setSelectedSupplier(found || null);
      setIsEditing(true);
      setShowAddForm(true);
      return;
    }
    if (path.endsWith("/supplier-management")) {
      setShowAddForm(false);
      setIsEditing(false);
      setSelectedSupplier(null);
    }
  }, [location.pathname, params.supplierCode, suppliers, setIsEditing, setSelectedSupplier, setShowAddForm]);

  const handleAddNewRoute = () => {
    navigate("/supplier-management/new");
  };

  const handleEditRoute = (row) => {
    const code = row?.suppliercode || row?.supplierCode;
    if (!code) return;
    navigate(`/supplier-management/${code}/edit`);
  };

  const handleCancelRoute = () => {
    navigate("/supplier-management");
  };

  return (
    <div className={styles.wrapper}>
      <Navbar />
      <div className={styles.dashboardLayout}>
        <main className={styles.main}>
          <div className={styles.container}>
            <SupplierFormContainer
              showAddForm={showAddForm}
              setShowAddForm={setShowAddForm}
              isEditing={isEditing}
              setIsEditing={setIsEditing}
              selectedSupplier={selectedSupplier}
              setSelectedSupplier={setSelectedSupplier}
              suppliers={suppliers}
              setSuppliers={setSuppliers}
              activeFilter={activeFilter}
              setActiveFilter={setActiveFilter}
              search={search}
              setSearch={setSearch}
              onEdit={handleEditRoute}
              onEnable={handleEnable}
              onDisable={handleDisable}
              onAddNew={handleAddNewRoute}
              onCancelForm={handleCancelRoute}
            />
          </div>
        </main>
      </div>
      <div className={styles.footerWrapper}>
        <Footer />
      </div>
      {/* Global success popup */}
      <Popup
        type="success"
        message={popupMsg}
        onClose={() => setPopupMsg("")}
      />
    </div>
  );
}
